import { render, staticRenderFns } from "./TresultTests.vue?vue&type=template&id=9a50b0fe"
import script from "./TresultTests.vue?vue&type=script&lang=js"
export * from "./TresultTests.vue?vue&type=script&lang=js"
import style0 from "./TresultTests.vue?vue&type=style&index=0&id=9a50b0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports